var exports = {
  "zr": "IncomingCallUI.module__root___R1pyVV",
  "Nr": "IncomingCallUI.module__card___R1pyVV",
  "BU": "IncomingCallUI.module__dragHandle___R1pyVV",
  "IH": "IncomingCallUI.module__dragPill___R1pyVV",
  "t$": "IncomingCallUI.module__stack___R1pyVV",
  "wx": "IncomingCallUI.module__header___R1pyVV",
  "nr": "IncomingCallUI.module__headerIcon___R1pyVV",
  "my": "IncomingCallUI.module__avatar___R1pyVV",
  "sI": "IncomingCallUI.module__callerInfo___R1pyVV",
  "XF": "IncomingCallUI.module__callerName___R1pyVV",
  "_n": "IncomingCallUI.module__callerSubtitle___R1pyVV",
  "o1": "IncomingCallUI.module__actions___R1pyVV",
  "mH": "IncomingCallUI.module__actionGroup___R1pyVV",
  "T$": "IncomingCallUI.module__circleButton___R1pyVV",
  "FM": "IncomingCallUI.module__circleButtonAccept___R1pyVV",
  "cK": "IncomingCallUI.module__circleButtonReject___R1pyVV",
  "V6": "IncomingCallUI.module__circleButtonIconRotated___R1pyVV",
  "ZJ": "IncomingCallUI.module__actionLabel___R1pyVV",
  "rw": "IncomingCallUI.module__ignoreLink___R1pyVV",
  "IR": "IncomingCallUI.module__screenReaderOnly___R1pyVV",
  "Po": "IncomingCallUI.module__bottomSheetStack___R1pyVV",
};

module.exports = exports;
